import * as React from 'react';
import { CheckBox } from '../CheckBox';

interface containerProps {
  onChange: (filter: string) => void
  options: Option[]
  optionClass?: string
}

interface containerState {
  isEnabled: boolean
  options: Option[]
}

interface Option {
  isEnabled: boolean
  isChecked: boolean
  label: string
}

export class RadioGroup extends React.Component<containerProps, containerState> {
  state: containerState = {
    isEnabled: true,
    options: []
  }
  constructor(props) {
    super(props);
    this.state.options = this.props.options;
  }
  componentDidUpdate(prevProps: Readonly<containerProps>, prevState: Readonly<containerState>, snapshot?: any) {
    if (this.props != prevProps)
      this.state.options = this.props.options;
  }

  updateStatus(option: string) {
    let { options } = this.state;
    const { onChange } = this.props;
    let updatedOptions = []
    options.forEach((item) => {
      updatedOptions.push({ label: item.label, isChecked: (option == item.label), isEnabled: true });
    });
    this.setState({ options: updatedOptions });
    onChange(option);
  }

  render() {
    const { isEnabled, options } = this.state;
    return (
      <div>
        {options.map((option, idx) => {
          return (
            <div key={idx} className={this.props.optionClass}>
              <i className={(option.isChecked ? "far fa-dot-circle" : "far fa-circle")} onClick={() => {
                this.updateStatus(option.label);
              }}></i>&nbsp;{option.label}
            </div>
          );
        })}
      </div>
    );
  }
}